import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { CreateChancel, Input, CheckboxCustom, AddressInput } from 'components';
import { httpRequestsOnErrorsActions, systemActions } from 'store';
import { FindLoad, useModal } from 'utils';

export const AddBank = ({ info }) => {
    const ACTION_TYPE = info ? 'EDIT_BANK' : 'CREATE_BANK';
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const {
        handleSubmit,
        control,
        clearErrors,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        if (info) {
            reset(info);
        }
    }, [info]);

    useEffect(() => {
        return () => {
            clearErrors();
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        };
    }, []);
    const handleCreate = (data) => {
        if (info) {
            dispatch(systemActions.editBank(info.id, data));
        } else {
            dispatch(systemActions.createBank(data));
        }
    };

    return (
        <div style={{ width: 440 }}>
            <p className="modal-header-title">{info ? 'Edit Bank' : 'Add Bank'}</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <div className="full-width">
                        <Input
                            name="name"
                            label="Bank Name*"
                            variant="outlined"
                            control={control}
                            rules={{
                                required: 'Bank name is required.',
                            }}
                        />
                        {/*<Input*/}
                        {/*    name="accountHolderName"*/}
                        {/*    label="Account Holder Name*"*/}
                        {/*    variant="outlined"*/}
                        {/*    control={control}*/}
                        {/*    rules={{*/}
                        {/*        required: 'Account holder name is required.',*/}
                        {/*    }}*/}
                        {/*/>*/}
                        <Input
                            name="accountNumber"
                            label="Account Number"
                            variant="outlined"
                            type={'number'}
                            control={control}
                            // rules={{
                            //     required: 'Account number is required.',
                        />
                        <Input
                            name="routingNumber"
                            label="Routing Number"
                            variant="outlined"
                            type={'number'}
                            control={control}
                            // rules={{
                            //     required: 'Account number is required.',
                        />
                        <Controller
                            name="address"
                            control={control}
                            // rules={{ required: 'Bank address is required.' }}
                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                <AddressInput
                                    selectedAddress={value}
                                    setCurrentAddress={(val) => {
                                        onChange(val?.street ? val : null);
                                    }}
                                    errMessage={error?.message}
                                    oneInput={true}
                                    noSuite={true}
                                    placeholder={'Bank Address'}
                                />
                            )}
                        />
                        <CheckboxCustom name="default" label="Set as Default" control={control} />
                    </div>
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
